// extracted by mini-css-extract-plugin
export default {"custom_radio_group":"CheckInput_custom_radio_group__BbKR8","custom_label_group":"CheckInput_custom_label_group__iOxOM"};